import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchBarService {
  private openSubject$ = new Subject<void>();

  open(): void {
    this.openSubject$.next();
  }

  getOpenEvents(): Observable<void> {
    return this.openSubject$;
  }
}
